module.exports = __webpack_public_path__ + "img/04929826000190.1786780e.png";